import Vue from 'vue';
import { Component } from 'vue-property-decorator';
@Component({
  components: {
    'sub-navigation-title': async () => import('@/components/sub-navigation-title/SubNavigationTitle.vue')
  }
})
class BlockSidebar extends Vue {
  /**
   *
   */


  constructor() {
    super();
  }

}

export default BlockSidebar;


// WEBPACK FOOTER //
// ./src/containers/block/components/block-sidebar/index.ts